module.exports = __webpack_public_path__ + "nproperty_market_icon.svg";